import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    scriptUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    scriptDomain: 'd57e5842-f42f-46bc-a4ea-4a82bd82322c',
  }) as const) satisfies ConfigFn

export default config
